import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoMerchantClientContext } from "@redotech/redo-merchant-app-common/client/context";
import { CollectionNamesMultiSelect } from "@redotech/redo-merchant-app-common/components/collection-names-multi-select";
import type { CollectionState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { searchAllPlatformCollectionNames } from "../../../client/collections";

export const CollectionDetails = memo(function CollectionDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<CollectionState>) {
  const { t } = useTranslation();
  const client = useRequiredContext(RedoMerchantClientContext);
  return (
    <Flex dir="column" gap="xs">
      <CollectionNamesMultiSelect
        description={t(
          "The first 100 collections are shown by default. To access more, search by title.",
        )}
        disabled={disabled}
        label={t("Collections")}
        placeholder={t("Select collections...")}
        searchCollections={({ searchString, signal }) =>
          searchAllPlatformCollectionNames(client, { searchString, signal })
        }
        setValue={setState}
        value={state}
      />
      <Text fontSize="xs" fontWeight="semibold" textColor="secondary">
        {t(
          "Evaluated against the product's current collections (at the time of return)",
        )}
      </Text>
    </Flex>
  );
});
